exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flag-label {\n  padding-left: 3px;\n  text-transform: uppercase;\n}\n\n.visit-cell-tooltip {\n  white-space: normal;\n  text-align: left;\n}\n\n.result-with-comment {\n  text-decoration: underline;\n}\n\n.indicator {\n  cursor: pointer;\n  margin-left: 5px;\n}\n\n", ""]);

// exports
